import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TableSortState {
  column: string | null;
  direction: "asc" | "desc" | null;
}

interface SortState {
  [tableName: string]: TableSortState;
}

const initialState: SortState = {};

const sortSlice = createSlice({
  name: "sort",
  initialState,
  reducers: {
    setSort: (
      state,
      action: PayloadAction<{ tableName: string; column: string }>,
    ) => {
      const { tableName, column } = action.payload;

      if (!state[tableName]) {
        // Initialize sorting state for a new table if it doesn’t exist
        state[tableName] = { column: null, direction: null };
      }

      const currentSortState = state[tableName];

      if (currentSortState.column === column) {
        currentSortState.direction =
          currentSortState.direction === "asc" ? "desc" : "asc";
      } else {
        currentSortState.column = column;
        currentSortState.direction = "asc";
      }
    },
  },
});

export const { setSort } = sortSlice.actions;
export default sortSlice.reducer;
